module.exports = __webpack_public_path__ + "static/78-a2f9b792945955156c350e9920a505cc.png";